
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBeaconGeneralEast as ObiBeaconGeneralEastElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-beacon-general-east.js';
 
 
 

 
 export const ObiBeaconGeneralEast = createComponent({
   react: React,
   tagName: 'obi-beacon-general-east',
   elementClass: ObiBeaconGeneralEastElement,
   events: {
     
   }
  });
 
 